import React from 'react';
import { Box, Container, Alert, AlertTitle } from '@mui/material';
import { EmployeeNavigation } from './EmployeeNavigation';
import { Footer } from './Footer';
import { useAuth } from '@/contexts/AuthContext';

interface EmployeeLayoutProps {
  children: React.ReactNode;
  showNavigation?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

export const EmployeeLayout: React.FC<EmployeeLayoutProps> = ({ 
  children, 
  showNavigation = true,
  maxWidth = 'xl'
}) => {
  const { userProfile } = useAuth();

  // Security check - ensure user is actually an employee
  if (userProfile && userProfile.userGroup !== 'employees') {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Container maxWidth="md" sx={{ py: 4 }}>
          <Alert severity="error">
            <AlertTitle>Access Denied</AlertTitle>
            You do not have permission to access the employee administration area.
          </Alert>
        </Container>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {showNavigation && <EmployeeNavigation />}
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1,
          backgroundColor: 'grey.50',
          minHeight: 'calc(100vh - 64px)' // Account for AppBar height
        }}
      >
        <Container maxWidth={maxWidth} sx={{ py: 3 }}>
          {children}
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};